import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { format } from 'date-fns';

/**
 * Verifica se um consultor estava em período de experiência durante o mês de
 * competência informado. Avalia pela janela do mês (não pela data atual),
 * garantindo que o histórico de meses anteriores nunca mude.
 *
 * Usa a RPC `get_em_experiencia_no_mes(p_usuario_id, p_competencia)`.
 */
export function useEmExperiencia(userId: string | undefined, competencia: Date) {
  const competenciaStr = format(competencia, 'yyyy-MM');

  const query = useQuery({
    queryKey: ['em-experiencia-no-mes', userId, competenciaStr],
    queryFn: async () => {
      if (!userId) return false;
      const { data, error } = await supabase.rpc('get_em_experiencia_no_mes', {
        p_usuario_id: userId,
        p_competencia: competenciaStr,
      });
      if (error) throw error;
      return Boolean(data);
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });

  return {
    emExperiencia: query.data ?? false,
    isLoading: query.isLoading,
  };
}
